<template>
  <div>
    <table class="table data-table"
           v-if="materials.length">
      <thead>
      <tr>
<!--        <th>Id</th>-->
        <th>{{ $t('title') }}</th>
        <th>{{ $t('barcode') }}</th>
        <th>{{ $t('artikul') }}</th>
        <th>{{ $t('unit_of_measure') }}</th>
        <th>{{ $t('amount') }}</th>
        <th>{{ $t('price') }}</th>
        <th>{{ $t('sum') }}</th>
        <th v-if="editable"></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(i, ind) in materials"
          :key="`op-item-${ind}`">
<!--        <td :data-title="$t('id')">{{ i.id }}</td>-->
        <td :data-title="$t('name')"
            class="order-mob-0">
          {{ i.title }}
          <!--        <a v-b-popover.hover.html="quantityTitle(i.material)"-->
          <!--           style="cursor: help"-->
          <!--           v-if="object.warehouse && ['addition','write_off','consumption', 'consumption_manual', 'movement_from', 'movement_to'].includes(type)">-->
          <!--          <InfoSvg/>-->
          <!--        </a>-->
        </td>
        <td :data-title="$t('barcode')">{{ i.barcode }}</td>
        <td :data-title="$t('artikul')">{{ i.artikul }}</td>
        <td :data-title="$t('unit_of_measure')">{{ i.unit ? i.unit.title : units[i.unit_id] }}</td>
        <td :data-title="$t('amount')">
          <input v-if="editable"
                 v-model="i.amount"
                 class="form-control sm"/>
          <span v-else>{{ i.amount }}</span>
        </td>
        <td :data-title="$t('price')">
<!--          <input v-if="editable"-->
<!--                 v-model="i.sale_price"-->
<!--                 class="form-control sm"/>-->
<!--          <span v-else>{{ formatNumber(i.sale_price) }}</span>-->
          <span>{{ formatNumber(i.sale_price) }}</span>
        </td>
        <td :data-title="$t('total')">{{ formatCurrency(i.sale_price * i.amount) }}</td>
        <td v-if="editable"
            :data-title="$t('delete')">
          <a class="pointer"
             @click="deleteItem(ind)">
            <DeleteSvg class="svg-stroke-light"/>
          </a>
        </td>
        <MobileMoreArrow/>
      </tr>
      <tr class="font-weight-bold">
        <td colspan="6">{{ $t('total') }}</td>
        <td :colspan="editable ? 2 : 1">{{ formatCurrency(totalSum) }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import DeleteSvg from "@/assets/svg-vue/general/delete2.svg.vue"
import MobileMoreArrow from "@/components/parts/datatable/MobileMoreArrow.vue"
// import InfoSvg from "@/assets/svg-vue/general/info2.svg.vue"
import {computed, watch} from "vue"
import {formatCurrency, formatNumber} from "@/extensions/filters/filters"
import {useStore} from "vuex"

const store = useStore()

const props = defineProps({
  materials: {
    type: Array,
    required: true
  },
  editable: {
    type: Boolean,
    default: false
  },
})

const emit = defineEmits(['itemDeleted', 'changeFinished', 'costTotal'])

const units = computed(() => store.state.auth.units)
const totalSum = computed(() => props.materials.reduce((acc, curr) => acc + (curr.amount * curr.sale_price), 0))

const deleteItem = (index) => {
  emit('itemDeleted', index)
}

watch(() => props.materials, () => {
  emit('costTotal', totalSum.value, totalSum.value)
}, {
  deep: true
})
</script>
